import { Grid, MenuItem, TextField, useMediaQuery, useTheme } from '@mui/material';

import {
  DialogActions,
  DialogBody,
  DialogContainer,
  DialogTitle,
} from '../../../../common/components';
import { FUND_TYPE_OPTIONS } from '../../constants/puntajeConstants';
import { getGroupLabel } from '../../utils/puntajeFormatters';

const InitialBalanceDialog = ({
  open,
  onClose,
  form,
  setForm,
  groups,
  isLoading,
  onSave,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isEditMode = Boolean(form.uuid);

  return (
    <DialogContainer open={open} onClose={onClose} size={isMobile ? 'small' : 'medium'}>
      <DialogTitle>
        {isEditMode ? 'Editar Saldo Inicial' : 'Agregar Saldo Inicial'}
      </DialogTitle>

      <DialogBody>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              type="number"
              label="Año"
              value={form.year}
              onChange={(event) =>
                setForm((prev) => ({
                  ...prev,
                  year: event.target.value,
                }))
              }
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              select
              fullWidth
              label="Grupo"
              value={form.uuid_group}
              onChange={(event) =>
                setForm((prev) => ({
                  ...prev,
                  uuid_group: event.target.value,
                }))
              }
            >
              {groups.map((group) => (
                <MenuItem key={group.uuid} value={group.uuid}>
                  {getGroupLabel(group)}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              select
              fullWidth
              label="Fondo"
              value={form.fund_type}
              onChange={(event) =>
                setForm((prev) => ({
                  ...prev,
                  fund_type: event.target.value,
                }))
              }
            >
              {FUND_TYPE_OPTIONS.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              type="number"
              label="Saldo en cuotas"
              value={form.installments_balance}
              onChange={(event) =>
                setForm((prev) => ({
                  ...prev,
                  installments_balance: event.target.value,
                }))
              }
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Notas"
              value={form.notes}
              onChange={(event) =>
                setForm((prev) => ({
                  ...prev,
                  notes: event.target.value,
                }))
              }
            />
          </Grid>
        </Grid>
      </DialogBody>

      <DialogActions
        handleClose={onClose}
        handleSave={onSave}
        saveLabel={isEditMode ? 'Actualizar' : 'Guardar'}
        saveButtonProps={{ isLoading }}
      />
    </DialogContainer>
  );
};

export default InitialBalanceDialog;
